import {
    PROFILES_DELETE_FAILURE,
    PROFILES_DELETE_REQUEST,
    PROFILES_DELETE_SUCCESS,
} from 'actions';

const initialState = {
    deleting: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case PROFILES_DELETE_SUCCESS: {return {
            ...state,
            deleting: false,
            hasErrors: false,
        }}

        case PROFILES_DELETE_REQUEST: {return {
            ...initialState,
            deleting: true,
        }}

        case PROFILES_DELETE_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
